export default __webpack_public_path__ + "static/media/zumzi_benefits.1a66c9dc.png";